export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7f75677b93e83af7f43bec6fbc28feaf71c9b98907&name=sendEvent!'